var scroll_active_default = (() => {
    if (!customElements.get("scroll-active")) customElements.define("scroll-active", class ScrollActive extends HTMLElement {
        constructor() {
            super();
            this.mq = window.matchMedia("(max-width: 1024px)");
            this.checkScrollable = this.checkScrollable.bind(this);
        }
        checkScrollable() {
            const container = this.firstElementChild;
            if (!container || container.scrollWidth <= container.clientWidth) return;
            const active = container.querySelector("[data-active]") || this.querySelector("[data-active]");
            if (!active) return;
            const {left: cLeft, width: cWidth} = container.getBoundingClientRect();
            const {left: aLeft, width: aWidth} = active.getBoundingClientRect();
            container.scrollLeft = Math.max(0, aLeft - cLeft + container.scrollLeft - (cWidth - aWidth) / 2);
        }
        connectedCallback() {
            if (!this.querySelector("[data-active]")) return;
            this.checkScrollable();
            this.mq.addEventListener("change", this.checkScrollable);
        }
        disconnectedCallback() {
            this.mq.removeEventListener("change", this.checkScrollable);
        }
    });
})();